import { useState as S, useEffect as u } from "react";
function l(t) {
  const {
    api: r,
    columnApi: n,
    colId: c
  } = t, [i, e] = S(t.currentSort);
  function s() {
    e(t.currentSort);
  }
  return u(() => {
    e(t.currentSort);
  }, [t.currentSort]), u(() => (r.addEventListener("sortChanged", () => {
    const o = n.getColumnState().filter((d) => !!d.sort);
    (o == null ? void 0 : o[0].colId) !== c && e(void 0);
  }), () => {
    r.removeEventListener("sortChanged", () => {
      e(void 0);
    });
  }), [r, n, c]), {
    currentSort: i,
    onSort: s
  };
}
export {
  l as useSorter
};
//# sourceMappingURL=useSorter.js.map
